var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:rgb(17,24,39);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.5290537,9.529542 9.5290537,8.529542 3.4704595,8.529542 3.4704595,3.4704595 8.5290527,3.4704595  8.5290537,9.529542 9.5290537,9.529542 9.5290537,8.529542 9.5290537,9.529542 10.5290527,9.529542 10.5290527,1.4704599  1.4704599,1.4704599 1.4704599,10.529541 10.5290527,10.529541 10.5290527,9.529542  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "21.529541,9.529542 21.529541,8.529542 15.4699707,8.529542 15.4699707,3.4704595  20.529541,3.4704595 20.529541,9.529542 21.529541,9.529542 21.529541,8.529542 21.529541,9.529542 22.529541,9.529542  22.529541,1.4704599 13.4699717,1.4704599 13.4699717,10.529541 22.529541,10.529541 22.529541,9.529542  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.5290537,21.529541 9.5290537,20.529541 3.4704595,20.529541 3.4704595,15.4709473  8.5290527,15.4709473 8.5290537,21.529541 9.5290537,21.529541 9.5290537,20.529541 9.5290537,21.529541 10.5290527,21.529541  10.5290527,13.4709482 1.4704599,13.4709482 1.4704599,22.529541 10.5290527,22.529541 10.5290527,21.529541  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "21.529541,21.529541 21.529541,20.529541 15.4699707,20.529541 15.4699707,15.4709473  20.529541,15.4709473 20.529541,21.529541 21.529541,21.529541 21.529541,20.529541 21.529541,21.529541 22.529541,21.529541  22.529541,13.4709482 13.4699717,13.4709482 13.4699717,22.529541 22.529541,22.529541 22.529541,21.529541  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridView);
export default __webpack_public_path__ + "static/media/grid_view.73a8fc8ddf26516c16c827efa74c8f00.svg";
export { ForwardRef as ReactComponent };